const baseOrigin = window.location.origin;

const passConfig = {
    loginExample: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/login_example.png',
    passStatic: "https://passport.baidu.com/passApi/js/uni_wrapper.js",
    passStaticQA: "https://passport.qatest.baidu.com/passApi/js/uni_wrapper.js",
    v3Jump: baseOrigin + "/static/pc-fe/v3Jump.html",
    v3JumpLocal: baseOrigin + "/v3Jump.html",
};

export default passConfig;
